import { FaFaceFrown } from "react-icons/fa6";
export default function NotFound() {
  return (
    <section className="relative mt-28 py-14 z-10 w-[80%] mx-auto flex flex-col gap-4 justify-center items-center">
      <FaFaceFrown fontSize="2.4em" />
      <p className="text-xl font-medium text-red-500 text-center">
        No exercise found for selected Muscle and Intensity Level. Try different
        options
      </p>
    </section>
  );
}
